'use es6';

import { createContext } from 'react';
export const ConnectDragSourceContext = /*#__PURE__*/createContext();
ConnectDragSourceContext.displayName = 'ConnectDragSourceContext';
const {
  Consumer,
  Provider
} = ConnectDragSourceContext;
export { Provider as ConnectDragSourceContextProvider };
export { Consumer as ConnectDragSourceContextConsumer };